/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Tour_Account_BodyInputs */



/**
* | output |
* | --- |
* | "Profile, security, language and theme. Support and What's New live here too." |
*
* @param {Onboarding_Tour_Account_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_tour_account_body = /** @type {((inputs?: Onboarding_Tour_Account_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Tour_Account_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Profil, Sicherheit, Sprache und Design. Support und Neuigkeiten findest du hier ebenfalls.")
	return /** @type {LocalizedString} */ ("Profile, security, language and theme. Support and What's New live here too.")
});